import SEOHead from '@/components/SEOHead';
import PartenairesHeroV2 from '@/components/marketing/partenaires/v2/PartenairesHeroV2';
import PartenairesProblemV2 from '@/components/marketing/partenaires/v2/PartenairesProblemV2';
import PartenairesHowItWorksV2 from '@/components/marketing/partenaires/v2/PartenairesHowItWorksV2';
import PartenairesPillarsV2 from '@/components/marketing/partenaires/v2/PartenairesPillarsV2';
import { FinalCtaSection } from '@/components/marketing/v2/FinalCtaSection';

export default function Partenaires() {
  return (
    <>
      <SEOHead
        title="Dépôt-vente & partenaires — Consignation traçable | Velko"
        description="Le module partenaire de Velko : confie des produits en dépôt-vente ou source en consignation chez un grossiste. Suivi du stock confié, soldes dus, quota par partenaire, facture avec QR code et garantie produit. Web, desktop, mobile — même hors ligne."
        path="/partenaires"
        ogImage="/brand/og/og-partenaires.png"
        breadcrumbs={[
          { name: 'Accueil', path: '/' },
          { name: 'Partenaires', path: '/partenaires' },
        ]}
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'SoftwareApplication',
          name: 'Velko — Partenaires & dépôt-vente',
          applicationCategory: 'BusinessApplication',
          operatingSystem: 'Web, Windows, macOS, Linux, Android',
          description:
            "Module de gestion des partenaires et de la consignation pour point de vente : dépôt-vente bidirectionnel, suivi du stock confié et des soldes, quota par partenaire, facture avec QR code, garantie produit.",
          offers: {
            '@type': 'Offer',
            priceCurrency: 'XOF',
            price: '0',
          },
        }}
      />

      <PartenairesHeroV2 />
      <PartenairesProblemV2 />
      <PartenairesHowItWorksV2 />
      <PartenairesPillarsV2 />
      <FinalCtaSection
        eyebrow="Étends ta force de vente"
        title="Plus de partenaires."
        highlight="Zéro ardoise oubliée."
        subtitle="Confie, source, suis et facture en consignation — avec QR code et garantie. Velko tient le stock confié et les soldes à jour pour toi."
        primaryLabel="Commencer gratuitement"
        primaryTo="/register"
        secondaryLabel="Voir les tarifs"
        secondaryTo="/tarifs"
        guarantees={['Dépôt-vente 2 sens', 'Facture QR', 'Hors ligne natif', 'Support FR']}
      />
    </>
  );
}
